import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { CasesState } from '../../states/cases.state';
import { CreateCaseCommand } from '../../../domain/commands';
import { CreateCaseResult } from './create-case.result';

/**
 * Create case use case.
 * Creates a new Case and updates state.
 */
@Injectable({ providedIn: 'root' })
export class CreateCaseUseCase {
  private readonly _repository = inject(CasesRepository);
  private readonly _state = inject(CasesState);

  /**
   * Executes the create case use case.
   * @param command - The command containing case creation data
   * @returns Observable with result containing the new Case ID and number
   */
  public execute(command: CreateCaseCommand): Observable<CreateCaseResult> {
    this._state.setSavingCases(true);
    this._state.setErrorCases(null);

    return this._repository.createCase(command).pipe(
      tap(() => {
        this._state.setSavingCases(false);
      }),
      map((result) => ({
        caseId: result.caseId,
        caseNumber: result.caseNumber,
      })),
      catchError((error) => {
        this._state.setErrorCases(error.message || 'Failed to create Case');
        this._state.setSavingCases(false);
        return throwError(() => error);
      }),
    );
  }
}
